import { combineEpics, ofType } from "redux-observable";
import { of, from, Observable, mergeMap, catchError } from "rxjs";
import { AnyAction } from "redux";
import { RootStateOrAny } from "react-redux";
import {
  loginFailure,
  loginSuccess,
  verifyAuthFailure,
  verifyAuthSuccess,
} from "./actions";
import {
  succeededRequest,
  failedRequest,
  clearRequest,
} from "../request/action";
import { fetchUser } from "../user/action";

import { loginUsecase } from "../../core/usecases/interactors/auth/login";
import { logoutUsecase } from "../../core/usecases/interactors/auth/logout";
import { sendResetPasswordEmailUsecase } from "../../core/usecases/interactors/auth/sendResetPasswordEmail";
import { confirmPasswordResetUsecase } from "../../core/usecases/interactors/auth/confirmPasswordReset";
import {
  LOGIN,
  SEND_RESET_PASSWORD_EMAIL,
  CONFIRM_PASSWORD_RESET,
  LOGOUT,
  VERIFY_AUTH,
} from "./actionType";

import { errorString } from "../../utils/strings";
import { data as constants } from "../../constants";
import { verifyAuthUseCase } from "../../core/usecases/interactors/auth/verifyAuth";

export const loginEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  { authInteractor }: { authInteractor: { login: loginUsecase } }
) =>
  action$.pipe(
    ofType(LOGIN),
    mergeMap(({ payload: { email, password } }) => {
      return from(authInteractor.login(email, password)).pipe(
        mergeMap((response) => {
          if (response.user) {
            const { id, email, isAdmin, token, name, isSuperAdmin } = response.user;
            return of(
              fetchUser(id, isAdmin),
              loginSuccess({ id, token, name, isAdmin, email, isSuperAdmin }),
            );
          }
          return of(loginFailure("User does not exists."));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          setTimeout(() => {
            errorMessage.includes(constants.commonNetworkError) &&
              window.location.reload();
          }, 1000);
          return of(loginFailure(errorMessage));
        })
      );
    })
  );

export const logoutEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  { authInteractor: { logout } }: { authInteractor: { logout: logoutUsecase } }
) =>
  action$.pipe(
    ofType(LOGOUT),
    mergeMap(() => {
      return from(logout()).pipe(
        mergeMap(() => of(succeededRequest(LOGOUT), clearRequest())),
        catchError((error) => {
          const errorMessage = errorString(error);
          return of(failedRequest(LOGOUT, errorMessage));
        })
      );
    })
  );

export const verifyAuthEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    authInteractor: { verifyAuth },
  }: { authInteractor: { verifyAuth: verifyAuthUseCase } }
) =>
  action$.pipe(
    ofType(VERIFY_AUTH),
    mergeMap(() => {
      return from(verifyAuth()).pipe(
        mergeMap((response) =>
          of(succeededRequest(VERIFY_AUTH), verifyAuthSuccess(response))
        ),
        catchError((error) => {
          const errorMessage = errorString(error);
          if (errorMessage.includes(constants.commonNetworkError)) {
            return of(window.location.reload());
          }
          return of(
            failedRequest(VERIFY_AUTH, errorMessage),
            verifyAuthFailure(errorMessage)
          );
        })
      );
    })
  );

export const sendResetPasswordEmailEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    authInteractor: { sendResetPasswordEmail },
  }: {
    authInteractor: { sendResetPasswordEmail: sendResetPasswordEmailUsecase };
  }
) =>
  action$.pipe(
    ofType(SEND_RESET_PASSWORD_EMAIL),
    mergeMap(({ payload: { email } }) => {
      return from(sendResetPasswordEmail(email)).pipe(
        mergeMap(() => of(succeededRequest(SEND_RESET_PASSWORD_EMAIL))),
        catchError((error) => {
          errorString(error).includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(
            failedRequest(SEND_RESET_PASSWORD_EMAIL, errorString(error))
          );
        })
      );
    })
  );

export const confirmPaswordResetEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    authInteractor: { confirmPasswordReset },
  }: { authInteractor: { confirmPasswordReset: confirmPasswordResetUsecase } }
) =>
  action$.pipe(
    ofType(CONFIRM_PASSWORD_RESET),
    mergeMap(({ payload: { code, newPassword } }) => {
      return from(confirmPasswordReset(code, newPassword)).pipe(
        mergeMap(() => of(succeededRequest(CONFIRM_PASSWORD_RESET))),
        catchError((error) => {
          errorString(error).includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(failedRequest(CONFIRM_PASSWORD_RESET, errorString(error)));
        })
      );
    })
  );

export default combineEpics(
  loginEpic,
  // @ts-ignore
  verifyAuthEpic,
  logoutEpic,
  sendResetPasswordEmailEpic,
  confirmPaswordResetEpic
);
